/** API route map: URLS.Controller.EmployeeEducation */
export const EmployeeEducation = {
      Name: 'EmployeeEducation/',
      GetEducations: 'get-all',
      AddEducation: 'add',
      UpdateEducation: 'update',
      DeleteEducation: 'delete',
};
